import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeleteConfirmationComponent } from '@bst-frontend/common-ui';
import {
  CommonService,
  CONSTANT,
  LoaderService,
  ObservableService,
  OrderService,
  TruckService,
} from '@bst-frontend/shared';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, Subject } from 'rxjs';
import { UpdateLrComponent } from '../modals/update-lr/update-lr.component';

@Component({
  selector: 'bst-frontend-truck-detail',
  templateUrl: './truck-detail.component.html',
  styleUrls: ['./truck-detail.component.css'],
})
export class TruckDetailComponent implements OnInit {
  truckId!: string | null;
  truckData: any = {};
  orderType: any = CONSTANT.orderType;

  //User Address
  dataRender: Subject<string> = new Subject<string>();
  dataConfig: any = [];
  filterColumns: any;
  page = 'trucks';
  nextPageUrl = 'order/view-orde/';
  selectedType: string | undefined;

  constructor(
    private truckService: TruckService,
    private activeRoute: ActivatedRoute,
    private modalService: NgbModal,
    private orderService: OrderService,
    private loader: LoaderService,
    private observableService: ObservableService,
    private common: CommonService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.selectedType = params['selectedType'] || this.selectedType;
    });
    this.truckId = this.activeRoute.snapshot.paramMap.get('id');
    this.page = `${this.page}/${this.truckId}/suborders`;
    if (this.truckId) {
      this.getDetails();
      this.setDataConfig();
    }
  }

  private setDataConfig() {
    this.dataConfig = {
      columns: [
        {
          title: 'LR No',
          name: 'lrNo',
          data: null,
          defaultContent: '',
          render: (data: any) => {
            return `<div class="order-detail">
            <p> ${data?.truckAssignment?.lrNumber}</p>
            </div>`;
          },
        },
        {
          title: 'Pickup Location',
          data: null,
          name: 'pickupLocation',
          defaultContent: '',
          render: (data: any) => {
            return `<div class="order-detail">
            <p> ${data?.pickup?.address?.companyName}</p>
            </div>`;
          },
        },
        {
          title: 'Customer Name',
          data: null,
          name: 'customerName',
          defaultContent: '',
          render: (data: any) => {
            return `<div class="order-detail">
            <p> ${data?.orderBy?.name}</p>
            </div>`;
          },
        },
        {
          title: 'Quantity',
          data: null,
          name: 'qty',
          defaultContent: '',
          render: (data: any) => {
            return `<div class="order-detail">
            <p> ${data?.totals?.actualQty}Box</p>
            </div>`;
          },
        },
        {
          title: 'weight',
          data: null,
          name: 'weight',
          defaultContent: '',
          render: (data: any) => {
            return `<div class="order-detail">
            <p> ${data?.totals?.actualWeight}KG</p>
            </div>`;
          },
        },
        {
          title: 'Tempo',
          name: 'tempo',
          data: null,
          defaultContent: '',
          render: (data: any) => {
            return `<div class="order-detail">
            <p> ${data?.truckAssignment?.tempoNo}</p>
            </div>`;
          },
        },
        {
          title: 'STATUS',
          data: null,
          name: 'status',
          defaultContent: '',
          render: (data: any) => {
            const label = data?.state?.label;
            return `<span class="status ${this.statusClass(data?.state?.code)}">
                    ${label}
              </span>`;
          },
        },
        {
          title: 'ACTION',
          data: null,
          className: 'datatable-action-button',
          orderable: false,
          defaultContent: '',
          render: (data: any) => {
            const className = data.invoiceNumber
              ? 'btn-secondary'
              : 'btn-primary';
            const name = data.invoiceNumber ? 'Updated LR' : 'Update LR';
            return `
             <button 
        class="btn ${className} btn-sm action-update-lr"
        data-action="update-lr"
      >
        ${name}
      </button>
            <a href="order/order-detail/${data?.orderId}?selectedType=${this.selectedType}&truckId=${this.truckId}" class="btn btn-primary btn-sm">View Order</a>`;
          },
        },
      ],
      createdRow: (row: Node, data: any) => {
        $(row)
          .find('.action-update-lr')
          .off('click')
          .on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.openUpdateLRModal(data); // 👈 Angular method
          });
      },
      fixedColumns: {
        right: 1,
        left: 0,
      },
    };
  }

  updateDataTable = true;
  openUpdateLRModal(data: any) {
    const modalRef = this.modalService.open(UpdateLrComponent, {
      centered: true,
      size: 'lg', // options: sm, lg, xl
      backdrop: 'static', // optional: prevent closing by click outside
    });

    modalRef.componentInstance.initialData = data;
    modalRef.result
      .then((result) => {
        this.updateDataTable = false;
        if (result.status === 'saved') {
          setTimeout(() => {
            this.updateDataTable = true;
          }, 10);
          this.dataRender.next('');
          console.log('estimate added!');
        }
      })
      .catch(() => {
        console.log('errror');
      });
  }

  statusClass(state: string) {
    const statusData: any = {
      requested: 'status-requested',
      estimated: 'status-confirmation',
      inProcess: 'status-inprocess',
      rejected: 'status-counter-Offer',
      'truck-assigned': 'status-vehicleassign',
      outForPickUp: 'status-vehiclethere',
      dispatched: 'status-dispatch',
      delivered: 'status-delivered',
      paid: 'status-orderpaid',
      cancelled: 'status-ordercancel',
    };
    return statusData[state];
  }

  getDetails() {
    this.truckService.getAssignTruckDetail(this.truckId).subscribe({
      next: (resp) => {
        this.truckData = resp.data;
      },
    });
  }

  intransitp() {
    const modalRef = this.modalService.open(DeleteConfirmationComponent, {
      centered: true,
      backdrop: 'static',
    });

    modalRef.componentInstance.title = 'Are you sure In transit ?';
    modalRef.componentInstance.message = `This action will confirm that vehicle ${this.truckData?.truckId?.truckNumber} has In transit. Please verify before proceeding.`;
    modalRef.componentInstance.confirmText = 'Yes, Confirm';
    modalRef.componentInstance.cancelText = 'Cancel';

    const payload = {
      notes: 'In transit.',
    };

    modalRef.result
      .then((result) => {
        if (result === 'confirm') {
          this.loader.show();

          this.orderService
            .updateOrderTruck(
              CONSTANT.orderStatus['IN-TRANSIT'],
              this.truckId!,
              payload
            )
            .pipe(finalize(() => this.loader.hide()))
            .subscribe({
              next: (res: any) => {
                if (res.status === 'success') {
                  this.common.navigateByUrl('/order');
                }
              },
              error: (err) => {
                console.error('Delete error', err);
              },
            });
        }
      })
      .catch(() => {
        console.log('errror');
      });
  }
}
